import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { UpdateRoute, updateRoute } from '~/generated';
import { extractData } from '~/utils/query-utils';

export type CustomUpdateRouteParam = Omit<UpdateRoute, 'meetingPlace'> & {
  meetingPlace?: string | null;
};

export const useEditRoute = (
  id: number,
  options: UseMutationOptions<unknown, unknown, CustomUpdateRouteParam, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: CustomUpdateRouteParam) =>
      extractData(
        updateRoute({
          body: {
            ...values,
            id,
            meetingPlace: values.meetingPlace ?? undefined,
          } as UpdateRoute,
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['routes'],
      });
      options.onSuccess?.(...args);
    },
  });
};
